import { useQuery } from "@tanstack/react-query";
import { listMyDevices } from "../api/ingestKeys";
import { ApiError } from "../api/client";

const MY_DEVICES_QUERY_KEY = ["tawa", "workers", "devices"];

// Relu toutes les 5 min : un poste qui se tait doit passer au rouge sans
// recharger la page. Un 404 signifie que l'API n'est pas encore déployée :
// inutile d'insister.
export function useMyDevices() {
  return useQuery({
    queryKey: MY_DEVICES_QUERY_KEY,
    queryFn: listMyDevices,
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
    refetchOnWindowFocus: "always",
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.status === 404) &&
      failureCount < 1,
  });
}
